/*
 * NB9060 — Zoom clicável para las fotos de "Elige tu color favorito"
 * Cada foto de esa grilla se vuelve clicável: al hacer clic se abre grande
 * en un modal, y al pasar el mouse por encima aparece un efecto de zoom
 * (lupa), igual que en las grandes tiendas (Nike, Amazon, etc).
 * No modifica ninguna otra parte del tema.
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Encuentra el encabezado "Elige tu color favorito" y su grilla de fotos.
    var headings = document.querySelectorAll('h2, h3');
    var heading = null;
    for (var i = 0; i < headings.length; i++) {
      if (headings[i].textContent && headings[i].textContent.trim().toLowerCase() === 'elige tu color favorito') {
        heading = headings[i];
        break;
      }
    }
    if (!heading) return;

    var section = heading.closest('section') || heading.parentElement;
    var grid = section ? section.querySelector('.nb9060-photogrid') : null;
    if (!grid) return;

    var items = grid.querySelectorAll('.nb9060-photogrid__item');
    if (!items.length) return;

    grid.classList.add('nb9060-photogrid--zoomable');

    // ---------- Estilos (inyectados una sola vez) ----------
    var style = document.createElement('style');
    style.textContent = [
      '.nb9060-photogrid--zoomable .nb9060-photogrid__item{cursor:zoom-in;position:relative;}',
      '.nb9060-photogrid--zoomable .nb9060-photogrid__item img{transition:transform .3s ease;}',
      '.nb9060-photogrid--zoomable .nb9060-photogrid__item:hover img{transform:scale(1.05);}',
      '.nb9060-photogrid--zoomable .nb9060-photogrid__item::after{content:"";position:absolute;inset:0;background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'white\' stroke-width=\'2\'%3E%3Ccircle cx=\'11\' cy=\'11\' r=\'7\'/%3E%3Cline x1=\'21\' y1=\'21\' x2=\'16.65\' y2=\'16.65\'/%3E%3Cline x1=\'11\' y1=\'8\' x2=\'11\' y2=\'14\'/%3E%3Cline x1=\'8\' y1=\'11\' x2=\'14\' y2=\'11\'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:center;background-size:34px;background-color:rgba(0,0,0,0);opacity:0;transition:opacity .2s ease,background-color .2s ease;pointer-events:none;}',
      '.nb9060-photogrid--zoomable .nb9060-photogrid__item:hover::after{opacity:1;background-color:rgba(0,0,0,.15);}',
      '.nb9060-zoom-modal{position:fixed;inset:0;z-index:99999;background:rgba(12,12,12,.94);display:flex;align-items:center;justify-content:center;padding:20px;opacity:0;visibility:hidden;transition:opacity .2s ease;}',
      '.nb9060-zoom-modal.is-open{opacity:1;visibility:visible;}',
      '.nb9060-zoom-modal__stage{position:relative;width:100%;max-width:900px;aspect-ratio:1/1;max-height:86vh;background:#fff;border-radius:14px;overflow:hidden;}',
      '.nb9060-zoom-modal__img{width:100%;height:100%;object-fit:contain;display:block;user-select:none;-webkit-user-drag:none;pointer-events:none;}',
      '.nb9060-zoom-lens{position:absolute;inset:0;background-repeat:no-repeat;opacity:0;pointer-events:none;transition:opacity .15s ease;}',
      '.nb9060-zoom-lens.is-ready{opacity:1;}',
      '@media (hover:hover) and (pointer:fine){.nb9060-zoom-modal__stage{cursor:zoom-in;}}',
      '.nb9060-zoom-modal__close{position:absolute;top:14px;right:14px;width:42px;height:42px;border-radius:50%;border:none;background:#fff;color:#111;font-size:24px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:2;box-shadow:0 2px 8px rgba(0,0,0,.25);}',
      '.nb9060-zoom-modal__hint{position:absolute;bottom:14px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,.6);color:#fff;font-size:12px;padding:6px 14px;border-radius:999px;white-space:nowrap;}',
      '@media (max-width:720px){.nb9060-zoom-modal__hint{display:none;}}'
    ].join('\n');
    document.head.appendChild(style);

    // ---------- Modal (creado una sola vez) ----------
    var modal = document.createElement('div');
    modal.className = 'nb9060-zoom-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<button type="button" class="nb9060-zoom-modal__close" aria-label="Cerrar">&times;</button>' +
      '<div class="nb9060-zoom-modal__stage">' +
      '<img class="nb9060-zoom-modal__img" src="" alt="">' +
      '<div class="nb9060-zoom-lens" aria-hidden="true"></div>' +
      '<span class="nb9060-zoom-modal__hint">Mueve el mouse sobre la imagen para hacer zoom</span>' +
      '</div>';
    document.body.appendChild(modal);

    var stage = modal.querySelector('.nb9060-zoom-modal__stage');
    var imgEl = modal.querySelector('.nb9060-zoom-modal__img');
    var lens = modal.querySelector('.nb9060-zoom-lens');
    var closeBtn = modal.querySelector('.nb9060-zoom-modal__close');
    var hint = modal.querySelector('.nb9060-zoom-modal__hint');
    var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var ZOOM_RATIO = 2.4;
    var lastFocused = null;

    function bigUrl(src) {
      // Pide una versión más grande al CDN de Shopify para que el zoom se vea nítido.
      if (!src) return src;
      var noQuery = src.split('?')[0];
      var query = src.indexOf('?') > -1 ? src.split('?')[1] : '';
      var params = query.split('&').filter(function (p) { return p && p.indexOf('width=') !== 0; });
      params.push('width=2200');
      return noQuery + '?' + params.join('&');
    }

    function openModal(src, alt) {
      lastFocused = document.activeElement;
      imgEl.src = bigUrl(src);
      imgEl.alt = alt || '';
      lens.style.backgroundImage = 'url(' + JSON.stringify(bigUrl(src)) + ')';
      lens.classList.remove('is-ready');
      if (hint) hint.style.display = supportsHover ? '' : 'none';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      lens.classList.remove('is-ready');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    items.forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) return;
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-label', 'Ampliar imagen: ' + (img.alt || 'producto'));

      function trigger() {
        var full = img.currentSrc || img.src;
        openModal(full, img.alt);
      }

      item.addEventListener('click', trigger);
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          trigger();
        }
      });
    });

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    if (supportsHover) {
      stage.addEventListener('mouseenter', function () {
        lens.classList.add('is-ready');
        if (hint) hint.style.opacity = '0';
      });
      stage.addEventListener('mousemove', function (e) {
        var rect = stage.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var xPct = (x / rect.width) * 100;
        var yPct = (y / rect.height) * 100;
        lens.style.backgroundSize = (rect.width * ZOOM_RATIO) + 'px ' + (rect.height * ZOOM_RATIO) + 'px';
        lens.style.backgroundPosition = xPct + '% ' + yPct + '%';
      });
      stage.addEventListener('mouseleave', function () {
        lens.classList.remove('is-ready');
        if (hint) hint.style.opacity = '1';
      });
    }
  });
})();